// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"2639d76d","78":"367051f6","113":"e578eacc","287":"0595095a","319":"20955ad6","337":"86f4bac2","372":"16cefb2f","481":"2cd409e8","488":"3993ea15","489":"be6be9f7","783":"d64c37b2","877":"45eb4dec","919":"c37c3bf3","921":"c7ed4f0a","981":"11e112eb"}[chunkId] + ".chunk.js";
};